export default function ctrlS(event, onSave) {
    let charCode = String.fromCharCode(event.which).toLowerCase();

    // Meta key for mac
    if (event.ctrlKey && charCode === 'c') {
        console.log("Ctrl + C pressed");
    } else if (event.ctrlKey && charCode === 'v') {
        console.log("Ctrl + V pressed");
    } else if (event.ctrlKey && charCode === 's') {
        event.preventDefault();
        console.log("Ctrl + S pressed");
        onSave();
    }

    // For metakey for MAC
    if (event.metaKey && charCode === 'c') {
        console.log("Cmd + C pressed");
    } else if (event.metaKey && charCode === 'v') {
        console.log("Cmd + V pressed");
    } else if (event.metaKey && charCode === 's') {
        event.preventDefault();
        console.log("Cmd + S pressed");
    }
}